module.exports = __webpack_public_path__ + "static/media/s2.61d83b92.png";